(function () {
  // Prevent double-install if script is included twice
  if (window.__PL_BUNDLE_HOOK_INSTALLED__) return;
  window.__PL_BUNDLE_HOOK_INSTALLED__ = true;

  // -----------------------------
  // Core helpers
  // -----------------------------
  function getCart() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(r => r.json());
  }

  function updateCart(updates) {
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates })
    }).then(r => r.json());
  }

  function forceImpulseDrawerRefresh() {
    try {
      // Best: Impulse ajaxCart load
      if (window.theme && window.theme.ajaxCart && typeof window.theme.ajaxCart.load === 'function') {
        window.theme.ajaxCart.load();
        return true;
      }
      if (window.ajaxCart && typeof window.ajaxCart.load === 'function') {
        window.ajaxCart.load();
        return true;
      }

      // Fallback events
      document.dispatchEvent(new CustomEvent('ajaxCart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('ajaxCart:afterCartLoad', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true }));
      return false;
    } catch (e) {
      console.warn('[PL bundle] forceImpulseDrawerRefresh failed', e);
      return false;
    }
  }

  // -----------------------------
  // Bundle cleanup
  // -----------------------------
  let cleaning = false;

  async function cleanupOrphanBundles() {
    if (cleaning) return;
    cleaning = true;

    try {
      const cart = await getCart();
      if (!cart || !cart.items) return;

      // group by bundle id
      const groups = {};
      cart.items.forEach(item => {
        const bid = item?.properties?._bundle_id;
        if (!bid) return;
        (groups[bid] ||= []).push(item);
      });

      const updates = {};
      Object.keys(groups).forEach(bid => {
        const group = groups[bid];
        const hasMain = group.some(i => i?.properties?._bundle_role === 'main');
        const hasAddon = group.some(i => i?.properties?._bundle_role === 'addon');

        // If either side missing, delete remaining
        if (!hasMain || !hasAddon) {
          group.forEach(i => { updates[i.key] = 0; });
        }
      });

      if (!Object.keys(updates).length) return;

      await updateCart(updates);

      // Strong refresh sequence (mobile needs multiple nudges)
      [30, 160, 450, 900].forEach(ms => setTimeout(forceImpulseDrawerRefresh, ms));

      // Also dispatch events with fresh cart detail (some builds rely on detail.cart)
      setTimeout(async () => {
        try {
          const fresh = await getCart();
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: fresh }, bubbles: true }));
          document.dispatchEvent(new CustomEvent('ajaxCart:afterCartLoad', { detail: { cart: fresh }, bubbles: true }));
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { cart: fresh }, bubbles: true }));
        } catch (_) {}
      }, 120);
    } finally {
      // small delay to avoid re-entrancy loops
      setTimeout(() => { cleaning = false; }, 250);
    }
  }

  // -----------------------------
  // Scheduler
  // -----------------------------
  let t = null;
  function scheduleCleanup(delay) {
    clearTimeout(t);
    t = setTimeout(() => cleanupOrphanBundles().catch(() => {}), delay);
  }

  // -----------------------------
  // FETCH HOOK (the key fix)
  // -----------------------------
  const origFetch = window.fetch;
  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : (input && input.url) ? input.url : '';

    const p = origFetch.apply(this, arguments);

    // Only react to cart mutations (theme + apps + drawer + mobile)
    if (
      url.includes('/cart/change') ||
      url.includes('/cart/update') ||
      url.includes('/cart/add')
    ) {
      p.then(() => {
        // Let theme finish its own render first, then we cleanup
        scheduleCleanup(650);
      }).catch(() => {});
    }

    return p;
  };

  // Safety: initial cleanup on load (if cart already has orphans)
  window.addEventListener('load', function () {
    scheduleCleanup(900);
  });
})();
